import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { ApplicationState } from "../../../store";

const BusinessCredit = (props: any) => {
    const businessProfileStatus = useSelector(
        (state: ApplicationState) =>
            state.loggedInUser &&
            state.loggedInUser.userServiceDetails?.businessProfileStatus?.filter((obj: any) => {
                return obj.provider;
            })
    );
    const creditProvider = businessProfileStatus != null && businessProfileStatus.length > 0 ? businessProfileStatus[0].provider : "";
    const [profileCreationStep, setProfileCreationStep] = useState(1);
    const [progressBar, setProgressBar] = useState("25%");
    const ensureDataFetched = () => {
        let step = 0;
        if (businessProfileStatus != null && businessProfileStatus.length > 0) {
            if (businessProfileStatus[0].status === "NONE") step = 0;
            //27037
            else if (businessProfileStatus[0].status === "NEW" || businessProfileStatus[0].status === "ACTIVE") step = 2;
            else if (businessProfileStatus[0].status === "SUBMITTED") step = 3;
            else if (businessProfileStatus[0].status === "COMPLETED") step = 4;
        }

        setProfileCreationStep(step);
        setProgressBar(step * 25 + "%");
    };

    useEffect(ensureDataFetched, [businessProfileStatus]);

    return (
        <React.Fragment>
            {profileCreationStep < 4 ? (
                <React.Fragment>
                    {profileCreationStep === 0 ? (
                        <div className="box">
                            <div className="box-header">
                                <div className="box-title-container">
                                    <div className="box-title-text has-actions">
                                        <h2 className="box-title">Business Credit</h2>
                                    </div>
                                </div>
                            </div>
                            <div className="box-content">
                                <p>
                                    Find and link your Business Credit Profile by clicking on the "Get Started" button. We will then monitor your profile and alert
                                    you of significant credit changes.
                                </p>

                                <p>
                                    <strong>You'll gain access to these features (and more!):</strong>
                                </p>

                                <div className="row margin-top-l">
                                    <div className="col-xs-12 col-md-3 col-gutter-vertical">
                                        <div className="service-container">
                                            <div className="service-icon">
                                                <span className="service-icon-container">
                                                    <em className="las la-tachometer-alt"></em>
                                                </span>
                                            </div>
                                            <div className="service-title padding-vertical-s">
                                                <strong>Business Credit Score</strong>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xs-12 col-md-3 col-gutter-vertical">
                                        <div className="service-container">
                                            <div className="service-icon">
                                                <span className="service-icon-container">
                                                    <em className="las la-calendar-day"></em>
                                                </span>
                                            </div>
                                            <div className="service-title padding-vertical-s">
                                                <strong>Days Beyond Terms (DBT)</strong>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xs-12 col-md-3 col-gutter-vertical">
                                        <div className="service-container">
                                            <div className="service-icon">
                                                <span className="service-icon-container">
                                                    <em className="las la-credit-card"></em>
                                                </span>
                                            </div>
                                            <div className="service-title padding-vertical-s">
                                                <strong>Recommended Credit Limit</strong>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xs-12 col-md-3 col-gutter-vertical">
                                        <div className="service-container">
                                            <div className="service-icon">
                                                <span className="service-icon-container">
                                                    <em className="las la-gavel"></em>
                                                </span>
                                            </div>
                                            <div className="service-title padding-vertical-s">
                                                <strong>Legal Filings</strong>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="margin-top-s">
                                    {props.selectedTab ? (
                                        <NavLink to={"/bcredit/get-started?selectedTab=" + props.selectedTab} className="btn-default btn-primary">
                                            <span className="btn-text">Get Started</span>
                                        </NavLink>
                                    ) : (
                                        <NavLink to="/bcredit/get-started" className="btn-default btn-primary">
                                            <span className="btn-text">Get Started</span>
                                        </NavLink>
                                    )}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="box">
                            <div className="box-header">
                                <div className="box-title-container">
                                    <div className="box-title-text has-actions">
                                        <h2 className="box-title">Business Credit</h2>
                                    </div>
                                </div>
                                <div className="box-actions">
                                    <span id="onboarding-status-complete">{progressBar}</span> Complete
                                </div>
                                <div className="box-helper">
                                    <div id="onboard-progress" className="onboard-progress-track">
                                        <div className="onboard-progress-value" style={{ width: progressBar }}></div>
                                    </div>
                                </div>
                            </div>
                            <div className="box-content">
                                <ul className="list-reset" id="onboarding-task-list">
                                    <li>
                                        <div className={`${profileCreationStep >= 1 ? "onboarding-task-container status-complete" : "onboarding-task-container"}`}>
                                            <span className="onboarding-task-icon">
                                                {profileCreationStep >= 1 ? <em className="las la-check-circle"></em> : <strong>1.</strong>}
                                            </span>
                                            <span className="onboarding-task-text">
                                                <p className="onboard-task-title">Submit Form</p>
                                                <p>We are currently verifying your business information. We will email you when we've initiated the next steps!</p>
                                            </span>
                                        </div>
                                    </li>

                                    <li>
                                        <div className={`${profileCreationStep >= 2 ? "onboarding-task-container status-complete" : "onboarding-task-container"}`}>
                                            <span className="onboarding-task-icon">
                                                {profileCreationStep >= 2 ? <em className="las la-check-circle"></em> : <strong>2.</strong>}
                                            </span>
                                            <span className="onboarding-task-text">
                                                <p className="onboard-task-title">Business Verification</p>
                                                <p>
                                                    Verifying your Business Credit Profile usually takes{" "}
                                                    {creditProvider != null && creditProvider === "CREDITSAFE" ? "5-10" : "30"} business days.
                                                </p>
                                            </span>
                                        </div>
                                    </li>

                                    <li>
                                        <div className={`${profileCreationStep >= 3 ? "onboarding-task-container status-complete" : "onboarding-task-container"}`}>
                                            <span className="onboarding-task-icon">
                                                {profileCreationStep >= 3 ? <em className="las la-check-circle"></em> : <strong>3.</strong>}
                                            </span>
                                            <span className="onboarding-task-text">
                                                <p className="onboard-task-title">Credit Profile Verification</p>
                                                <p>
                                                    Complete a list of personally tailored questions directly generated from information in your credit profile for
                                                    verification purposes.{" "}
                                                </p>
                                            </span>
                                        </div>
                                    </li>

                                    <li>
                                        <div className={`${profileCreationStep >= 4 ? "onboarding-task-container status-complete" : "onboarding-task-container"}`}>
                                            <span className="onboarding-task-icon">
                                                {profileCreationStep >= 4 ? <em className="las la-check-circle"></em> : <strong>4.</strong>}
                                            </span>
                                            <span className="onboarding-task-text">
                                                <p className="onboard-task-title">Link to your Business Profile</p>
                                                <p>Search for and add your business to link your business credit report.</p>
                                            </span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    )}
                </React.Fragment>
            ) : null}
        </React.Fragment>
    );
};

export default BusinessCredit;
